import { render, staticRenderFns } from "./block-loader.vue?vue&type=template&id=cd648836&scoped=true&"
import script from "./block-loader.vue?vue&type=script&lang=js&"
export * from "./block-loader.vue?vue&type=script&lang=js&"
import style0 from "./block-loader.vue?vue&type=style&index=0&id=cd648836&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd648836",
  null
  
)

export default component.exports